import React from 'react'

export default () => (
  <svg viewBox="0 0 32 32">
    <rect x=".5" y=".5" width="31" height="31" rx="15.5"/>
    <path d="M10 13.413 11.413 12 16 16.587 20.587 12 22 13.413l-6 6-6-6Z"/>
  </svg>
)
